// istanbul ignore file
const appPromise = import(/* webpackPreload: true */ './app/App');
import './prerender/markAppStart'; // mark the begging of the app's reading
import './prerender/staticImages'; // preload static images which are not served from s3
import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import i18n from './app/infrastructure/I18n/i18n';
import configureStore from './app/infrastructure/configureStore';
import './styles/main.scss';
import persistorContext from './app/infrastructure/persistorContext';
import { WMStylesProvider } from '@walkme/wm-ui';
import { I18nextProvider } from 'react-i18next';
import { persistStore } from 'redux-persist';
import logger from './app/services/logger.service';
import { monitorPageLoadTime } from './app/services/performence.service';
import AppSkeleton from './app/components/AppSkeleton/AppSkeleton';
import { createRequestInterceptors } from './app/services/http.service';
import WalkmeSdkProvider from './app/infrastructure/WalkmeSdkProvider/WalkmeSdkProvider';
import { ApolloProviderWrapper } from './app/ApolloProviderWrapper';
import AuthorizationGate from './app/infrastructure/AppAuthorization/AuthorizationGate';
import { BrowserRouter } from 'react-router-dom';
import PersistanceNavigator from './app/components/PersistanceNavigator';
import NavigateSetter from './app/components/NavigateSetter';
import { createRoot } from 'react-dom/client';


async function run() {
    logger.init();
    logger.log('admin com center init', { name: 'appInit' }, 'info');

    const App = React.lazy(() =>
        appPromise.then(app => {
            monitorPageLoadTime();

            return app;
        })
    );

    const store = configureStore();
    const persistor = persistStore(store, { manualPersist: true } as $TSFixMe);

    createRequestInterceptors({ store });

    const container = document.getElementById('root');
    const root = createRoot(container!);

    root.render(
        <Provider store={store}>
                <persistorContext.Provider value={persistor}>
                    <WMStylesProvider>
                        <I18nextProvider i18n={i18n}>
                        <BrowserRouter>
                            <NavigateSetter/>
                            <PersistanceNavigator>
                              <WalkmeSdkProvider>
                                  <ApolloProviderWrapper store={store}>
                                      <Suspense fallback={<AppSkeleton />}>
                                          <AuthorizationGate>
                                              <App/>
                                          </AuthorizationGate>
                                      </Suspense>
                                  </ApolloProviderWrapper>
                              </WalkmeSdkProvider>
                            </PersistanceNavigator>
                          </BrowserRouter>
                        </I18nextProvider>
                    </WMStylesProvider>
                </persistorContext.Provider>
        </Provider>,
    );
}

run();
